import styled from '@emotion/styled';
import sx from '@styled-system/css';
import { compose } from 'styled-system';
import { styles as textVariants } from '../text';
import variant from '@styled-system/variant';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { Theme } from '../theme';
import { InputProps } from './';
import { validStyle, invalidStyle, inputVariant } from './shared';

const TextArea = styled('textarea', { shouldForwardProp })(
  ({ variant = 'onWhite', valid, invalid }: InputProps & { rows?: number }) =>
    sx({
      ...textVariants['1r'],
      resize: 'none',
      position: 'relative',
      lineHeight: 1,
      width: '100%',
      padding: 4,
      border: 0,
      borderRadius: 1,
      willChange: 'padding',
      '&::placeholder': {
        color: 'gray.3',
      },
      transition:
        'box-shadow .1s linear, backgroundColor .1s linear, color .1s linear, padding .2s ease-out',
      '&:focus': {
        boxShadow: (theme: Theme) =>
          `inset 0 0 0 1px ${theme.colors.indigo[3]}`,
      },
      '&:not(:placeholder-shown)': {
        '&:invalid': !valid && invalidStyle,
        '&:valid': !invalid && validStyle,
      },
      ...(invalid && invalidStyle),
      ...(valid && validStyle),
      '&[disabled]': {
        cursor: 'not-allowed',
        backgroundColor: 'gray.6',
        color: 'gray.4',
        ...(variant === 'onBlack' && {
          backgroundColor: 'transparent',
          color: 'gray.4',
        }),
      },
    }),
  compose(inputVariant),
);

TextArea.defaultProps = {
  rows: 20,
};

export default TextArea;
